<template>
  <section>
    <div class="form">
      <div>
        <paragraph-header size="2" class="header">{{ $t('beginReservation') }}:</paragraph-header>
        <date-picker
          v-model="startDate"
          :locale="currentLanguage"
          :disabled-dates="disabledDates"
          :select-attribute="attribute"
        ></date-picker>
      </div>
      <div class="weeks_wrapper">
        <paragraph-header size="2" class="header">{{ $t('lengthOfTime') }}:</paragraph-header>
        <div class="weeks">
          <button
            v-for="n in [2, 3, 4]"
            type="button"
            :class="{ is_active: amount.weeks === n }"
            @click="amount.weeks = n"
            :key="n"
          >
            {{ n }}<span>&nbsp;{{ $tc('weeks', n) }}</span>
          </button>
          <the-dropdown
            @value-change="setMoreValue"
            :raw="true"
            :defaultValue="amount.weeks > 4 ? amount.weeks : null"
            :switchHover="true"
            :isDark="amount.weeks > 4"
            :options="weeks"
          ></the-dropdown>
        </div>
      </div>
    </div>
    <p class="disclaimer" v-if="items.length > 0">
      {{ $t('After changing any of this value your basket will be cleared.') }}
    </p>

    <i18n path="contactUsDirectlyForLargerMoves" class="subtext" tag="div">
      <a :href="`/${currentLanguage}/contact`">{{ $t('Contact') }}</a>
    </i18n>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'
import { attributes as calendarAttributes, disabledDates, minimumNumberOfWeeks } from '@/helpers/dataPickerSettings'
import ParagraphHeader from '../atoms/ParagraphHeader.vue'
import TheDropdown from '../TheDropdown.vue'
import i18n from '../../lang'

export default {
  name: 'ReservationUserNeeds',
  metaInfo: {
    title: i18n.t('beginReservation'),
  },
  components: {
    DatePicker,
    ParagraphHeader,
    TheDropdown,
  },
  data() {
    return {
      orderDaysGap: 3,
      moreValue: null,
      amount: {
        persons: 1,
        rooms: 1,
        weeks: minimumNumberOfWeeks,
      },
      attribute: calendarAttributes,
      disabledDates,
      weeks: [
        {
          value: null,
          label: 'More',
        },
        {
          value: 5,
          label: '5 weeks',
        },
        {
          value: 6,
          label: '6 weeks',
        },
        {
          value: 7,
          label: '7 weeks',
        },
        {
          value: 8,
          label: '8 weeks',
        },
      ],
    }
  },
  created() {
    this.amount.weeks = this.$store.state.cart.amountOfWeeks
  },
  computed: {
    ...mapState('cart', ['amountOfWeeks', 'items']),
    ...mapState('user', ['currentLanguage']),
    startDate: {
      set(value) {
        this.$store.commit('cart/setStartDate', value)
      },
      get() {
        return this.$store.state.cart.startDate
      },
    },
  },
  watch: {
    'amount.weeks'(newValue) {
      if (newValue < 5) {
        this.moreValue = null
      }
      this.$store.dispatch('cart/setAmountOfWeeks', newValue)
    },
    moreValue(newValue) {
      if (newValue > 4) this.amount.weeks = newValue
    },
    amountOfWeeks(newValue) {
      if (newValue > 4) {
        this.moreValue = newValue
      } else {
        this.amount.weeks = newValue
      }
    },
  },
  methods: {
    setMoreValue(value) {
      this.moreValue = value
    },
  },
}
</script>

<style lang="scss" scoped>
section {
  @include container;
}
.form {
  display: flex;
  flex-wrap: wrap;

  & > div {
    padding: 0px 20px 10px 0;
    margin-bottom: 50px;

    &:first-child {
      @include mq($from: tablet) {
        margin-right: 80px;
      }
    }
  }

  .header {
    padding-bottom: 18px;
  }
}

.disclaimer {
  @include fontStyleNavi;
  transform: translate(0, -50px);
}

.weeks {
  border: 1px solid #000;
  border-radius: 50px;
  padding: 10px;
  display: flex;

  button {
    @include fontStyleNavi;
    padding: 9px 14px;
    border-radius: 20px;
    border: 1px solid transparent;
    background: transparent;
    display: flex;
    cursor: pointer;
    margin-right: 5px;
    transition: background-color 0.3s, color 0.3s;

    &:hover {
      background: $colorBeigeDark;
    }

    span {
      display: inline-block;
      max-width: 0;
      overflow: hidden;
    }

    &.is_active {
      background: #000;
      color: #fff;

      span {
        max-width: 80px;
      }
    }
  }
}

.more_weeks {
  border: 0;
  outline: none;
  @include fontStyleNavi;
  background: transparent;
  transition: background-color 0.3s, color 0.3s;

  &.is_active {
    background: #000;
    color: #fff;
    border-radius: 20px;
    padding: 7px 12px;
  }
}

.subtext {
  @include fontStyleCopyRegular;
}
</style>
